module.exports = __webpack_public_path__ + "img/DOGE.d5b2e204.png";